import apiClient from '@/client/api';

export enum RiskProcessingStatus {
  inactive = 'inactive',
  processing = 'processing',
  processed = 'processed',
  error = 'error',
}

type RiskProcessingStatusResponse = {
  riskProcessingStatus: RiskProcessingStatus;
};

async function getRiskProcessingStatus(): Promise<RiskProcessingStatusResponse> {
  const response = await apiClient.get('/user/get-processing-status');
  return response.data;
}

async function triggerRiskReprocessing(): Promise<RiskProcessingStatusResponse> {
  const response = await apiClient.post('/user/trigger-risk-reprocessing');
  return response.data;
}

async function triggerPotentialRiskReprocessing(): Promise<RiskProcessingStatusResponse> {
  const response = await apiClient.post('/user/trigger-potential-risk-reprocessing');
  return response.data;
}

export default { getRiskProcessingStatus, triggerRiskReprocessing, triggerPotentialRiskReprocessing };
